function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function SelectImgComponent({ title, data, item, onchange }) {
  return (
    <div>
      <h2 className="text-sm font-medium text-gray-500">{title}</h2>
      <ul className="flex justify-between items-center mt-3">
        {data.map((ditem) => (
          <li
            key={ditem.id}
            onClick={() => onchange(ditem)}
            className={classNames(
              "flex shadow-sm p-1  cursor-pointer",
              ditem.id === item?.id ? "rounded-full bg-gray-400 " : "bg-white"
            )}
          >
            {ditem.name}
          </li>
        ))}
      </ul>
    </div>
  );
}
